import { render, staticRenderFns } from "./SearchFacetValues.vue?vue&type=template&id=a5c86568&lang=pug&"
import script from "./SearchFacetValues.vue?vue&type=script&lang=js&"
export * from "./SearchFacetValues.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports